import {Counter as CounterBase} from '@logistics-frontend/blocks'
import {Controller, useFormContext} from '@yandex-delivery/form'
import React from 'react'

import type {Props} from './Counter.types'

export function Counter({name, max, min, size, defaultValue, ...props}: Props): React.ReactElement {
  const {control} = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      render={({field, fieldState}) => {
        return (
          <div ref={field.ref}>
            <CounterBase
              error={fieldState.invalid}
              max={max}
              min={min}
              name={name}
              onBlur={field.onBlur}
              onChange={field.onChange}
              size={size}
              value={field.value || defaultValue}
              {...props}
            />
          </div>
        )
      }}
    />
  )
}
